var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5ZM22.4 12.5C22.4 6.75624 17.7438 2.1 12 2.1C6.25624 2.1 1.6 6.75624 1.6 12.5C1.6 18.2438 6.25624 22.9 12 22.9C17.7438 22.9 22.4 18.2438 22.4 12.5ZM11.2 18.7V17.3C11.2 16.8582 11.5582 16.5 12 16.5C12.4418 16.5 12.8 16.8582 12.8 17.3V18.7C12.8 19.1418 12.4418 19.5 12 19.5C11.5582 19.5 11.2 19.1418 11.2 18.7ZM11.2 14.7V6.3C11.2 5.85817 11.5582 5.5 12 5.5C12.4418 5.5 12.8 5.85817 12.8 6.3V14.7C12.8 15.1418 12.4418 15.5 12 15.5C11.5582 15.5 11.2 15.1418 11.2 14.7Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.359f7c5f.svg";
export { ForwardRef as ReactComponent };